import { ISearchPage, IPage, ITreeData } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IAboutUsDetail } from "../aboutUs/aboutUsService";
import { IIntroductionsDetail } from "../introductions/introductionsService";
import { IMdOrgDetail, IMdOrgFields } from "./OrgTypes";


//详情
export interface ICardDetail {
    id?: string,       // "1"
    address?: string,       // "1"
    businessProfiles?: string,       // 
    cardType?: string,       // "1"
    code?: string,       // "1"
    company?: string,       // "公司"
    companyProfiles?: string,       // "6872e62d603b0f650700dc6854030bf1"
    createTime?: string,       // null
    createUser?: string,       // null
    deleteFlag?: string,       // 0
    ebcBusinessDto?: IIntroductionsDetail,       // { id?:string,      ,… }
    ebcCompanyDto?: IAboutUsDetail,       // { id?:string,       电有限公司",… }
    email?: string,       // "邮箱"
    init?: string,       // "1"
    md5?: string,       // "图片md5"
    icon?: string | string[],       // "头像md5"
    logo?: string | string[],       // "头像md5"
    brandPicture?: string | string[],       // "头像md5"
    name?: string,       // "员工姓名"
    openid?: string,       // "1"
    orderNum?: string,       // 1
    depName?: string,       // "11"
    page?: string,       // null
    phone?: string,       // "手机号"
    position?: string,       // "职位"
    qrCode?: string,       // "1"
    status?: string,       // "1"
    tel?: string,       // "电话"
    title?: string,       // "1"
    updateTime?: string,       // 
    updateUser?: string,       // "管理员"
    userEntityId?: string,       // "1"
    wechat?: string,       // null
    current?: string,       //  当前选中
    style?: string,       // 样式
    website?: string,       // 网址
    isNameEn?: string,       // 是否展示英文
    nameEn?: string,       // 英文名称
}

//新增
export interface ICardInsert extends ICardDetail {

}

//编辑
export interface ICardUpdate extends ICardInsert {
    id: string,
}

//搜索条件
export interface ICardSearchFields {
    "depName"?: string,  // "11", 
    "name"?: string,  // "11", 
    "carType"?: string,  // "11", 
    "status"?: string,  // "11", 
}
export interface ICmSearchPageFields {
    page: ISearchPage;
}
export interface ICardSearch
    extends ICardSearchFields, ICmSearchPageFields {
}

//表单字段
export interface ICardFormFields {
    orgName?: string;
    orgCode?: string;
    brandPicture?: string | string[];
    "id"?: string,   // "1",
    "openid"?: string,   // "1",
    "name"?: string,   // "员工姓名",
    "phone"?: string,   // "手机号",
    "tel"?: string,   // "电话",
    "org_name"?: string,   // "部门名称",
    "position"?: string,   // "职位",
    "email"?: string,   // "邮箱",
    "company"?: string,   // "公司",
    "nameEn"?: string,   // "公司",
    "address"?: string,   // "公司",
    "isNameEn"?: string,   // "公司",
    "md5"?: string,   // "图片md5"
    "icon"?: string | string[],   // "图片md5"
    "logo"?: string | string[],   // "图片md5"
    "companyProfiles"?: string,   // "图片md5"
}

interface ITreeDs<T> {
    enable?: number;
    code?: string;
    children?: T[]
}

export function trasDsToTreeData<T extends ITreeDs<T>>(
    ds: T[],
    keyField: keyof T,
    titleField: keyof T,
): ITreeData<T>[] {
    return ds.map(el => {
        const key = el[keyField] as any;
        const title = el[titleField] as any;
        const children = el.children && el.children.length > 0 ? trasDsToTreeData(el.children, keyField, titleField) : undefined;
        const disabled = el.enable === 0;
        return {
            el,
            key,
            title,
            disabled,
            value: el["code"],
            selectable: !disabled,
            children,
        }
    });
}

class CardService {
    async page(searchVo: ICardSearch) {
        const apiUrl = "/ebc/card/search/pg";
        return await httpRequest.post<IPage<ICardDetail>>(apiUrl, searchVo);
    }
    /** 根据用户id查询名片信息  */
    async getCardById(userEntityId: string) {
        const apiUrl = `/ebc/card/selectByUserId/${userEntityId}`;
        return httpRequest.get<ICardDetail[]>(apiUrl);
    }
    /** 用户切换名片身份 -更改选中 */
    async updateCurrent(id: string) {
        const apiUrl = `/ebc/card/updateCurrent/${id}`;
        return httpRequest.get<boolean>(apiUrl);
    }
    async update(updateVo: ICardUpdate) {
        const apiUrl = "/ebc/card/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async insert(updateVo: ICardInsert) {
        const apiUrl = "/ebc/card/insert";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    //启用禁用
    async delete(id: string) {
        const apiUrl = `/ebc/card/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //用户同步接口
    async sync(obj: object) {
        const apiUrl = `/ebc/user/sync`;
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = `/ebc/card/downloadTpl`;
        return await httpRequest.getFile(apiUrl);
    }
    //导入组织机构
    async uploadOrg(params: any) {
        const apiUrl = `/ebc/card/uploadOrg`;
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
    /**
     * 全部树加载
     * @param params 
     * @returns 
     */
    async allTree(params: IMdOrgFields) {
        const apiUrl = "/portal/org/allTree";
        params.branchList = ["main", "portal"];
        return await httpRequest.post<IMdOrgDetail[]>(apiUrl, params)
    }


    async orgTreeDs(params: IMdOrgFields) {
        let { retData } = await this.allTree(params);
        // retData.map(el=>({
        //     label:el.name,
        //     value:el.code,
        //     children:[]
        // }))
        let treeData = trasDsToTreeData(retData, "code", "name");
        return treeData;
    }

}

export const cardService = new CardService();
